export default {
  errorMessage: '',
  error: '',
  notification: {
    message: '',
    type: '',
    iconName: '',
  },
  language: 'en',
  currency: 'kr.',
  importQueue: [],
  importQueueIds: [],
}
